import { render, staticRenderFns } from "./JPopup.vue?vue&type=template&id=1c1c48f3&scoped=true&"
import script from "./JPopup.vue?vue&type=script&lang=js&"
export * from "./JPopup.vue?vue&type=script&lang=js&"
import style0 from "./JPopup.vue?vue&type=style&index=0&id=1c1c48f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c48f3",
  null
  
)

export default component.exports